import { Component, OnInit, Input } from '@angular/core';
import { SetorCliente } from '../../comum/modelos/setor-cliente';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { PontoFisicoService } from '../../ponto-fisico/ponto-fisico.service';
import { Paginacao } from '../../comum/modelos/paginacao';

@Component({
  selector: 'app-ponto-fisico-setor',
  templateUrl: './ponto-fisico-setor.component.html',
  styleUrls: ['./ponto-fisico-setor.component.css']
})
export class PontoFisicoSetorComponent implements OnInit {

  @Input() setorCliente: SetorCliente;

  pontosFisicos: PontoFisico[];
  public paginacao: Paginacao;
  public filtroPesquisaRazaoSocialBind: string;

  statusCode: number;
  public loading = false;

  constructor(private _pontoFisicoService: PontoFisicoService) {
    this.pontosFisicos = new Array<PontoFisico>();
    this.paginacao = new Paginacao();
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    this._pontoFisicoService.obterPontosFisicosSetorHttp(this.setorCliente)
      .subscribe(pontosFisicos => {
        this.pontosFisicos = pontosFisicos.body;
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaRazaoSocialBind = filtro.value;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/ponto-fisico-setor/ponto-fisico-setor.component.ts